import { FaClock, FaEnvelope, FaFacebook, FaPhone } from 'react-icons/fa';

const Contact = () => {
  return (
    <div className="min-h-screen">
      <section className="hero-brand hero-brand-rocky text-white py-20">
        <div className="container text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">Contact Us</h1>
          <p className="text-xl max-w-3xl mx-auto">
            We&apos;d love to hear from you. Reach out through email and Facebook.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="panel p-8">
              <h2 className="text-3xl font-bold mb-4 text-brand-primary">Get in Touch</h2>
              <p className="text-brand-muted mb-8">
                The best way to connect with us right now is by email and Facebook.
              </p>

              <div className="space-y-6 panel-soft p-6">
                <div className="flex items-start">
                  <div className="text-red-500 mt-1 mr-4">
                    <FaPhone size={18} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-brand-ink">Phone Number</h3>
                    <p className="text-brand-muted">AOR</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="text-red-500 mt-1 mr-4">
                    <FaEnvelope size={18} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-brand-ink">Email Address</h3>
                    <p className="text-brand-ink">
                      <a
                        href="mailto:info@MinistriesForChrist.net"
                        className="text-brand-primary hover:underline break-all"
                      >
                        info@MinistriesForChrist.net
                      </a>
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="icon-brand mt-1 mr-4">
                    <FaClock size={18} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-brand-ink">Service Times</h3>
                    <p className="text-brand-muted">Bible study schedule shared privately.</p>
                  </div>
                </div>

                <div className="pt-4 mt-6 border-t border-gray-200">
                  <h3 className="text-xl font-semibold mb-4 text-brand-ink">Social Links</h3>
                  <div className="flex space-x-6">
                    <a
                      href="https://www.facebook.com/profile.php?id=61573569402755&sk=about"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 transition-colors"
                      aria-label="Facebook"
                    >
                      <FaFacebook size={28} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
